import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getAppStartTime } from 'flow/selectors/selectors';

class IntervalRenderer extends React.Component {
    static propTypes = {
        interval: PropTypes.number.isRequired,
        appStartTime: PropTypes.number.isRequired,
        children: PropTypes.func.isRequired,
    };

    start() {
        const { appStartTime, interval } = this.props;
        const diff = Date.now() - appStartTime;
        const remainder = diff % interval;

        this.intervalId = window.setInterval(() => {
            clearInterval(this.intervalId);
            this.intervalId = window.setInterval(() => {
                this.forceUpdate();
            }, interval);
        }, remainder);
    }

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = 0;
        }
    }

    componentDidMount() {
        this.start();
    }

    componentWillUnmount() {
        this.stop();
    }

    render() {
        const { children } = this.props;
        return children();
    }
}

const mapStateToProps = (state) => {
    return {
        appStartTime: getAppStartTime(state),
    };
};

export default connect(mapStateToProps)(IntervalRenderer);
